<template>
  <div class="g">
    <!-- <div class="btnGuide" @click="handleShow">
      <i class="icon_quest"></i>新手引导
    </div> -->
    <CoverLayout v-if="isShow">
      <div class="guideLayout" slot="content">
        <div class="pre" @click="handlePre"></div>
        <div class="guide">
          <div class="title">新手引导</div>
          <div class="step">
            <div class="stepTag">
              <span class="currentStep">{{ step }}</span>
              <span class="totalStep">/7</span>
            </div>
            <div class="stepTitle">
              {{ stepTitle[step] }}
            </div>
          </div>
          <div class="stepText">
            {{ stepText[step] }}
          </div>
          <div class="imgBox">
            <img class="stepImg" :src="`/static/gpic${step}.png`" alt="" />
          </div>
          <div class="foot">
            <div class="remember">
              <el-checkbox v-model="rememberHide" style="margin-right:7px"
                >下次登录不显示</el-checkbox
              >
            </div>
            <Btn
              btnText="关闭新手引导"
              @handleClick="handleClose"
              :width="162"
              :height="38"
            />
          </div>
        </div>
        <div class="next" @click="handleNext"></div>
      </div>
    </CoverLayout>
  </div>
</template>

<script>
import Btn from "./Btn.vue";
import CoverLayout from "./CoverLayout.vue";
export default {
  components: { CoverLayout, Btn },
  data() {
    return {
      isShow: false,
      rememberHide: JSON.parse(localStorage.getItem("showGuide")) || false,
      step: 1,
      stepText: {
        1: "基于国家数据平台的信息安全规范，溯源优才平台用户均为实名用户，请先完成实名认证。",
        2: "数据档案中展示本人全部数据档案数据，数据来源包括自填、国际公信力权威部门、学校/企业/社会机构。您可在此页面中查看和完善数据",
        3: "您可根据您的需求选择性勾选数据生成个人信息报告，个人信息报告可通过电子证书授权允许他人查看，生成后的个人信息报告不可再次修改。",
        4: "每份个人信息报告可生成多个授权查验的电子证书；每份电子证书可单独设置授权时间和次数，被授权者扫码即可查验您的个人信息报告。",
        5: "他人扫描电子证书或查验卡片中的二维码，实名登录即可查验数据报告。",
        6: "输入准确的姓名和手机号码，向他人发起实名查验申请，他人同意并授权后即可查看其个人数据报告。",
        7: "他人向您发起的查验申请，您可以在查验申请页面中查看和处理。"
      },
      stepTitle: {
        1: "实名认证：",
        2: "数据档案：",
        3: "个人信息报告:",
        4: "授权电子证书：",
        5: "授权电子证书：",
        6: "查验报告：",
        7: "查验申请授权："
      }
    };
  },
  methods: {
    handleShow() {
      this.isShow = true;
    },
    handleClose() {
      this.isShow = false;
      if (this.rememberHide) {
        localStorage.setItem("showGuide", JSON.stringify(this.rememberHide));
      }
    },
    handlePre() {
      this.step = this.step <= 1 ? 1 : this.step - 1;
    },
    handleNext() {
      if (this.step + 1 < 8) {
        this.step = this.step + 1;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.g {
  display: inline-block;
  margin-left: 12px;
  z-index: 1;
  .btnGuide {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon_quest {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_quest.png")
        no-repeat;
      background-size: cover;
      width: 15px;
      height: 15px;
      display: inline-block;
      margin-right: 5px;
    }
  }
}
.guideLayout {
  display: flex;
  align-items: center;
  .pre {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pre_dark.png")
      no-repeat;
    background-size: cover;
    width: 39px;
    height: 80px;
    margin-right: 20px;
    cursor: pointer;
  }
  .next {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pre_dark.png")
      no-repeat;
    background-size: cover;
    width: 39px;
    height: 80px;
    margin-left: 20px;
    transform: rotate(180deg);
    cursor: pointer;
  }
  .guide {
    width: 816px;
    height: 633px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/guideBox_bg.png");
    background-size: cover;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    //   align-items: center;
    box-sizing: border-box;
    padding: 32px 116px 41px 116px;
    .imgBox {
      height: 358px;
      // margin-top: 40px;
      .stepImg {
        width: 100%;
        max-height: 349.58px;
      }
    }
    .stepText {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #393939;
      // line-height: 24px;
      // height: 60px;
      min-height: 60px;
    }

    .title {
      text-align: center;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #3a61b1;
    }
    .step {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #393939;
      line-height: 24px;
      display: flex;
      align-items: baseline;
      .stepTitle {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #3a61b1;
        line-height: 41px;
      }
      .stepTag {
        display: flex;
        align-items: baseline;
        margin-right: 12px;
      }
      .currentStep {
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #3a61b1;
        // line-height: 57px;
      }
      .totalStep {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #8d8d8d;
        // line-height: 57px;
      }
    }
    .foot {
      text-align: center;
      margin-top: 5px;
      input {
        border: 1px solid #d8d8d8;
        border-radius: 4px;
      }
      .remember {
        margin-bottom: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Guide.vue